import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { motion } from 'framer-motion';

export default function LanguageSwitch({ useWhiteText = true, compact = false }) {
  const { language, toggleLanguage } = useLanguage();
  const { isDark } = useTheme();
  const isSpanish = language === 'es';

  // Thumb color: blue in dark, maroon in light
  const thumbBg = isDark ? 'bg-blue-500' : 'bg-[#800020]';

  // Text labels adapt to context
  const labelActive = useWhiteText ? 'text-white font-medium' : isDark ? 'text-white font-medium' : 'text-gray-900 font-medium';
  const labelInactive = useWhiteText ? 'text-gray-300' : isDark ? 'text-gray-500' : 'text-gray-400';
  const separatorCls = useWhiteText ? 'text-gray-400' : isDark ? 'text-gray-600' : 'text-gray-400';

  // Outer border
  const outerCls = isDark
    ? 'bg-white/5 border-white/10 hover:border-blue-500/50'
    : useWhiteText
      ? 'bg-white/5 border-white/20 hover:border-white/40'
      : 'bg-gray-50 border-gray-200 hover:border-red-300';

  // Track
  const trackCls = isDark
    ? 'bg-black/50 border-white/20'
    : useWhiteText
      ? 'bg-black/30 border-white/20'
      : 'bg-gray-200 border-gray-300';

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center border transition-all group ${
        compact ? "gap-0 px-2 py-2" : "gap-2.5 sm:gap-3 px-3.5 sm:px-4 py-2"
      } ${outerCls}`}
      data-testid="language-switch"
      aria-label={`Switch to ${isSpanish ? 'English' : 'Spanish'}`}
    >
      <div className={`relative w-14 h-7 border rounded-full shrink-0 ${trackCls}`}>
        <motion.div
          className={`absolute top-0.5 w-6 h-6 ${thumbBg} rounded-full flex items-center justify-center`}
          animate={{ left: isSpanish ? '28px' : '2px' }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        >
          <span className="text-[10px] font-bold text-white leading-none">
            {isSpanish ? 'ES' : 'EN'}
          </span>
        </motion.div>
      </div>
      
      {!compact && (
      <div className="flex items-center gap-1 sm:gap-1.5 text-[11px] sm:text-sm font-medium tracking-wide uppercase whitespace-nowrap">
        <span className={`transition-colors ${!isSpanish ? labelActive : labelInactive}`}>
          English
        </span>
        <span className={separatorCls}>/</span>
        <span className={`transition-colors ${isSpanish ? labelActive : labelInactive}`}>
          Español
        </span>
      </div>
      )}
    </button>
  );
}
